export default (text) => {
    return text.replaceAll('\n', '<br>')
}
